import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { UserCustomActions } from "./types.js";
addProp(_List, "userCustomActions", UserCustomActions);
//# sourceMappingURL=list.js.map